import { headerBgBase64 } from './HeaderBgStore.js';

export const updateHeaderBgBase64 = (value) => headerBgBase64.update(oldValue => value);
